import { IconButton, Tooltip, useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { Fragment, useEffect, useState } from "react";
import MaterialSymbol from "../icons/material-symbol";
import InstagramIcon1 from "../icons/instagram-icon1";
import IconYouTube from "../icons/icon-youtube";
import { Link } from "react-router-dom";
import storyIcon from '../../assets/images/story.svg';
import reelsIcon from '../../assets/images/reels.svg';
import digitalRightsIcon from '../../assets/images/digital-rights.svg';
import shortsIcon from '../../assets/images/shorts.svg';
import dedicatedVideoIcon from '../../assets/images/dedicated-video.svg';
import integratedVideoIcon from '../../assets/images/integrated-video.svg';
import { format } from 'date-fns';


interface Props {
  proposalId: number;
  campaignImage: string;
  campaignTitle: string;
  campaignType: string;
  campaignStatus: string;
  campaignId: number;
  completed: boolean;
  completedAt: Date;
  campaignPlatform: string;
  proposalStatus: string;
  creativeApproveCount: number;
  creativePendingCount: number;
  creativeRejectedCount: number;
  AppliedDate: string;
  invoiceCount: number | string;
  deliverables: string;
  analyticsCount:string | number;
  posted_days_count: string;
  handleCampaign: (
    url: string,
    campaignId: number,
    campaignPlatform: string
  ) => void;
  btnName: string;
  markProposalComplete: (proposal_id: number, campaign_title: string) => any;
  createdAt: string;
  activeTab: "applied" | "completed";  
}


const MyCampaignCard: React.FC<Props> = ({
  proposalId,
  invoiceCount,
  campaignImage,
  campaignTitle,
  campaignType,
  campaignStatus,
  campaignPlatform,
  campaignId,
  completed,
  completedAt,
  proposalStatus,
  creativeApproveCount,
  creativePendingCount,
  creativeRejectedCount,
  AppliedDate,
  handleCampaign,
  markProposalComplete,
  deliverables,
  posted_days_count,
  analyticsCount,
  btnName,
  createdAt,
  activeTab
}) => {
  const campingStatus = [
    {
      name: "Applied",
      url: `/influencer/campaign/proposal`,
      applied_date: AppliedDate,
    },
    { name: "Proposal", url: `/influencer/campaign/proposal` },
    {
      name: "Creatives",
      url: `/influencer/campaign/creative`,
      approve: creativeApproveCount,
      pending: creativePendingCount,
      reject: creativeRejectedCount,
    },
    { name: "Analytics", url: `/influencer/campaign/analytics` },
    {
      name: completed ? "Marked Complete" : "Mark Complete",
      url: ``,
    },
  ];
const campingStatusMobile = [
  {
    name: "Applied",
    url: `/influencer/campaign/proposal`,
    applied_date: AppliedDate,
  },
  { name: "Status", url: `/influencer/campaign/proposal` }, // renamed
  {
    name: "Creatives",
    url: `/influencer/campaign/creative`,
    approve: creativeApproveCount,
    pending: creativePendingCount,
    reject: creativeRejectedCount,
  },
  { name: "Add Post Link", url: `/influencer/campaign/analytics` }, // renamed
  { name: "Invoice", url: `/influencer/campaign/sendinvoice` }, // ✅ NEW
];
  const [currentStepIndex, setCurrentStepIndex] = useState<number | null>(null);
  const [accordionActive, setAccordionActive] = useState(false);

  useEffect(() => {
    const findCurrentStepIndex = () => {
      for (let i = 0; i < campingStatus.length; i++) {
        const status = campingStatus[i];
        if (
          status.name === "Proposal" &&
          ["Pending", "Accepted", "Rejected", "Negotiating"].includes(
            proposalStatus
          )
        ) {
          return i;
        }
        if (
          status.name === "Creatives" &&
          proposalStatus === "Accepted" &&
          campaignType !== "Barter" &&
          ["Hold", "Live"].includes(campaignStatus)
        ) {
          return i;
        }
        if (
          status.name === "Analytics" &&
          creativeApproveCount > 0 &&
          ["Hold", "Live"].includes(campaignStatus)
        ) {
          return i;
        }
      }
      return null;
    };

    setCurrentStepIndex(findCurrentStepIndex());
  }, [
    campingStatus,
    proposalStatus,
    campaignStatus,
    campaignType,
    creativeApproveCount,
  ]);

  const handleAccordionClick = (
    e: any,
    campaignId: number,
    campaignPlatform: string
  ) => {
    e.stopPropagation();
    setAccordionActive((prev: boolean) => !prev);
  };

  // function handleCLickEvents(e: any) {
  //   if (e.target.classList.contains("mark-complete-event")) {
  //     e.preventDefault();
  //     markProposalComplete(proposalId, campaignTitle);
  //   } else {
  //     handleCampaign(
  //       "/influencer/campaign/campaigndetails",
  //       campaignId,
  //       campaignPlatform
  //     );
  //   }
  //   // handleCampaign('/influencer/campaign/campaigndetails', campaignId, campaignPlatform)
  // }
   const isDisabled = (
    proposalStatus === "Accepted" &&
    Number(creativeApproveCount) > 0 &&
    Number(invoiceCount) > 0
  );
    const isDisabledOther = (
    proposalStatus !== "Accepted" &&
    Number(creativeApproveCount) === 0 &&
    Number(invoiceCount) === 0
  );
  function handleCLickEvents(e: any) {
  if (!isDisabled && !isDisabledOther) {
    e.stopPropagation(); // Stop event propagation
    e.preventDefault();  // Prevent default action
    return;
  }

  if (e.target.classList.contains("mark-complete-event")) {
    e.preventDefault();
    markProposalComplete(proposalId, campaignTitle);
  } else {
    handleCampaign(
      "/influencer/campaign/campaigndetails",
      campaignId,
      campaignPlatform
    );
  }
}
  const isMobile = useMediaQuery("(max-width:768px)");
  const isCompletedTab = activeTab === "completed";
  const [startX, setStartX] = useState(0);
const [translateX, setTranslateX] = useState(0);
// const isCompleted = completed === 'true';
// const canMarkComplete =
//   !isCompleted &&
//   (
//     (
//       campaignStatus === 'Accepted' &&
//       item.approved_count > 0 &&
//       item.invoice_count > 0
//     ) ||
//     (
//       item.status === 'Pending' ||
//       item.status === 'Negotiating'
//     )
//   );
const isCompleted = completed;



const canMarkComplete =
  !isCompleted &&
  (
    (
      proposalStatus === "Accepted" &&
      Number(creativeApproveCount) > 0 &&
      Number(invoiceCount) > 0
    ) ||
    (
      proposalStatus === "Pending" ||
      proposalStatus === "Negotiating"
    )
  );



const handleTouchStart = (e: React.TouchEvent) => {
  setStartX(e.touches[0].clientX);
};

const handleTouchMove = (e: React.TouchEvent) => {
  const currentX = e.touches[0].clientX;
  const diff = startX - currentX;

  // 👉 Allow BOTH directions but clamp between 0 and 120
  let newTranslate = diff;

  // Clamp values
  if (newTranslate < 0) newTranslate = 0;       // no right overflow
  if (newTranslate > 120) newTranslate = 120;   // max open

  setTranslateX(newTranslate);
};

const handleTouchEnd = () => {
  // 👉 SNAP logic
  if (translateX > 60) {
    setTranslateX(120); // open
  } else {
    setTranslateX(0);   // close
  }
};
const deliverableIcons: any = {
  story: storyIcon,
  reels: reelsIcon,
  'digital rights': digitalRightsIcon,
  shorts: shortsIcon,
  'dedicated video':dedicatedVideoIcon,
  'integrated video':integratedVideoIcon,
};
// const getStepStatus = (stepIndex: number) => {
//   switch (stepIndex) {
//     case 0:
//       return { color: "green", isCompleted: true, isRejected: false };

//     case 1:
//       if (proposalStatus === "Accepted") {
//         return { color: "green", isCompleted: true, isRejected: false };
//       } else if (proposalStatus === "Rejected") {
//         return { color: "red", isCompleted: false, isRejected: true };
//       } else if (proposalStatus === "Pending") {
//         return { color: "orange", isCompleted: false, isRejected: false };
//       }
//       return { color: "gray", isCompleted: false, isRejected: false };

//     case 2:
//       if (creativeApproveCount > 0) {
//         return { color: "green", isCompleted: true, isRejected: false };
//       } else if (creativeRejectedCount > 0) {
//         return { color: "red", isCompleted: false, isRejected: true };
//       } else if (creativePendingCount > 0) {
//         return { color: "orange", isCompleted: false, isRejected: false };
//       }
//       return { color: "gray", isCompleted: false, isRejected: false };

//     case 3:
//       return {
//         color: Number(creativeApproveCount) > 0 ? "green" : "gray",
//         isCompleted: Number(creativeApproveCount) > 0,
//         isRejected: false,
//       };

//     case 4:
//       return {
//         color: Number(invoiceCount) > 0 ? "green" : "gray",
//         isCompleted: Number(invoiceCount) > 0,
//         isRejected: false,
//       };

//     default:
//       return { color: "gray", isCompleted: false, isRejected: false };
//   }
// };
const getStepStatus = (stepIndex: number) => {
  switch (stepIndex) {
    case 0: // Applied
      return { color: "#4CAF50", isCompleted: true, isRejected: false };

    case 1: // Status
      if (proposalStatus === "Accepted") {
        return { color: "#4CAF50", isCompleted: true, isRejected: false };
      } else if (proposalStatus === "Rejected") {
        return { color: "red", isCompleted: false, isRejected: true };
      } else if (proposalStatus === "Pending") {
        return { color: "#248ECC", isCompleted: false, isRejected: false };
      }
      return { color: "#dadada", isCompleted: false, isRejected: false };

    case 2: // Creatives
      if (creativeApproveCount > 0) {
        return { color: "#4CAF50", isCompleted: true, isRejected: false };
      } else if (creativeRejectedCount > 0) {
        return { color: "red", isCompleted: false, isRejected: true };
      } else if (creativePendingCount > 0) {
        return { color: "#248ECC", isCompleted: false, isRejected: false };
      }
      return { color: "#dadada", isCompleted: false, isRejected: false };

    case 3: // ✅ Add Post Link (FIXED)
      return {
        color: Number(analyticsCount) > 0 ? "#4CAF50" : "#dadada",
        isCompleted: Number(analyticsCount) > 0,
        isRejected: false,
      };

    case 4: // Invoice
      return {
        color: Number(invoiceCount) > 0 ? "green" : "#dadada",
        isCompleted: Number(invoiceCount) > 0,
        isRejected: false,
      };

    default:
      return { color: "gray", isCompleted: false, isRejected: false };
  }
};  
return (
    <>{isMobile ? (<>
  <div className="swipe-container">

    {/* RIGHT ACTION */}
    {/* <div
  className={`swipe-action ${canMarkComplete ? "active" : "disabled"}`}
  onClick={() => {
    if (canMarkComplete) {
      markProposalComplete(proposalId, campaignTitle);
    }
  }}
>
  {canMarkComplete ? (
    <>
      <MaterialSymbol iconName="check_circle" iconFilled fontweight="200" fontSize="30px" />
      <p>Mark as<br/> Complete</p>
    </>
  ) : (
    <>
      <MaterialSymbol iconName="block" fontweight="200" fontSize="30px" />
      <p>Mark as<br/> Complete</p>
    </>
  )}
</div> */}
<div
  className={`swipe-action ${
    isCompletedTab ? "completed" : canMarkComplete ? "active" : "disabled"
  }`}
  onClick={() => {
    if (!isCompletedTab && canMarkComplete) {
      markProposalComplete(proposalId, campaignTitle);
    }
  }}
>
  {isCompletedTab ? (
    <>
      <MaterialSymbol fontweight="200" iconName="check_circle" iconFilled fontSize="28px" />
      <p>
        Completed at <br />
        {completedAt
          ? format(new Date(completedAt), "dd MMM yyyy, hh:mm a")
          : ""}
      </p>
    </>
  ) : canMarkComplete ? (
    <>
      <MaterialSymbol fontweight="200" iconName="check_circle" iconFilled fontSize="30px" />
      <p>Mark as<br /> Complete</p>
    </>
  ) : (
    <>
      <MaterialSymbol fontweight="200" iconName="block" fontSize="30px" />
      <p>Mark as<br /> Complete</p>
    </>
  )}
</div>

    {/* MAIN CARD */}
    <div
      className="swipe-card"
      onClick={() => {
        if (translateX > 0) {
          setTranslateX(0); // close
        }
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      style={{ transform: `translateX(-${translateX}px)` }}
    >
      <div
        onClick={!isDisabled && !isDisabledOther ? undefined : (e) => handleCLickEvents(e)}
        className="my-campaign-card"
      >
        <div className="my-campaign-card-left">
          <img src={campaignImage} alt="" />

          <div className="d-flex flex-column flex-md-row w-100 align-items-md-center align-items-start">
            <div className="d-flex items-start gap-1">
              <span className="badge badge-primary-outline d-inline-flex d-md-none ms-md-2 campaign-type-container">
                
                {campaignPlatform === "Instagram" && (
                  <>
                    <InstagramIcon1 width={15} height={15} />
                    {campaignType}
                  </>
                )}
                {campaignPlatform === "Youtube" && (
                  <>
                    <IconYouTube width={20}  height={15} />
                    {campaignType}
                  </>
                )}
              </span>
              {/* {completed && <span className="badge badge-primary-outline d-inline-flex" style={{height:'25px'}}>Completed</span>}

              {createdAt && <span className="badge badge-primary-outline"  style={{height:'25px'}}>Applied</span>} */}
              {completed ? (
                <span className="badge badge-primary-outline d-inline-flex" style={{ height: '25px', backgroundColor:'#4CAF50', color:'#fff' }}>
                  Completed
                </span>
              ) : (
                createdAt && (
                  <span className="badge badge-primary-outline" style={{ height: '25px' }}>
                    Applied
                  </span>
                )
              )}
            </div>
            <h5
              onClick={() =>
                handleCampaign(
                  "/influencer/campaign/campaigndetails",
                  campaignId,
                  campaignPlatform
                )
              }
            >
              {campaignTitle}
            </h5>
            <span className="fs-12 pb-2">Posted {posted_days_count} days ago</span>
            <span className="badge badge-primary-outline d-md-inline-flex ms-md-2 d-none">
              {campaignPlatform === "Instagram" && (
                <>
                  <InstagramIcon1 width={20} height={20} />
                  {campaignType}
                </>
              )}
              {campaignPlatform === "Youtube" && (
                <>
                  <IconYouTube width={20} height={20} />
                  {campaignType}
                </>
              )}
            </span>
            
          </div>
        </div>
        <div className="chips">
          {deliverables?.split(',').map((d: string) => {
              const label = d.trim();
              const key = label.toLowerCase();

              return (
              <span key={d} className="chip">
                  {deliverableIcons[key] && (
                  <img src={deliverableIcons[key]} alt={label} />
                  )}
                  <span className='chip-text'>{label}</span>
              </span>
              );
          })}
        </div>
        {/* ✅ Progress */}
        <div className="campaign-progress">
          {campingStatusMobile?.map((status, index) => {
            
          const stepStatus = getStepStatus(index);
            return (
              // <div
              //   key={index}
              //   className={`progress-step 
              //     ${isCompleted ? "completed" : ""} 
              //     ${isActive ? "active" : ""}`}
              // >
              //   <div className="step-label">
              //     <div className="step-label-text">
              //       {status.name === "Proposal"
              //         ? "Status"
              //         : status.name}
              //     </div>
              //     <div className="step-icon">
              //       {isCompleted ? "✔" : ""}
              //     </div>

              //   </div>
              // </div>
              <>
              <div
  key={index}
  className={`progress-step 
    ${stepStatus.isCompleted ? "completed" : ""} 
    ${stepStatus.isRejected ? "rejected" : ""}`}
>
   <div className="step-label-text">
    {status.name === "Proposal" ? "Status" : status.name}
  </div>
  <div
    className="step-circle"
    style={{ backgroundColor: stepStatus.color }}
  >
    {stepStatus.isCompleted ? <MaterialSymbol iconName="check_small" fontweight="200" /> : ""}
    {stepStatus.isRejected ? <MaterialSymbol iconName="close_small" fontweight="200" /> : ""}
  </div>

 
</div>
</>
            );
          })}
          
        </div>
        <span style={{fontSize:'11px', color:'#666', paddingTop:'5px'}}>{format(new Date(createdAt), 'dd MMMM')} &nbsp; My Response</span>
      </div>
    </div>

  </div>
</>) :
      (<div onClick={!isDisabled && !isDisabledOther ? undefined : (e) => handleCLickEvents(e)} className="my-campaign-card">
        <div className="my-campaign-card-left">
          <img src={campaignImage} alt="" />
          <div className="d-flex flex-column flex-md-row w-100 align-items-md-center align-items-start">
            <h5
              style={{ color: "#00aae5" }}
              onClick={() =>
                handleCampaign(
                  "/influencer/campaign/campaigndetails",
                  campaignId,
                  campaignPlatform
                )
              }
            >
              {campaignTitle}
            </h5>

            <span className="badge badge-primary-outline d-inline-flex ms-md-2">
              {campaignPlatform === "Instagram" && (
                <>
                  <InstagramIcon1 width={20} height={20} />
                  {campaignType}
                </>
              )}

              {campaignPlatform === "Youtube" && (
                <>
                  <IconYouTube width={20} height={20} />
                  {campaignType}
                </>
              )}
            </span>
          </div>
          <IconButton
            className="ms-auto d-inline-flex d-md-none"
            onClick={(e: any) =>
              handleAccordionClick(e, campaignId, campaignPlatform)
            }
          >
            <MaterialSymbol
              className={accordionActive ? "active" : ""}
              iconName={`${
                accordionActive ? "keyboard_arrow_up" : "keyboard_arrow_down"
              }`}
              fontweight="200"
            />
          </IconButton>
        </div>
        <div
          className={`my-campaign-card-right ${accordionActive ? "active" : ""}`}
        >
          <>
            {campingStatus?.map((status, index) => {
              const isPreviouslySelected =
                currentStepIndex !== null && index < currentStepIndex;
              const isCurrentStep =
                currentStepIndex !== null && index === currentStepIndex;
                  const isDisabled = (
                    proposalStatus === "Accepted" &&
                    Number(creativeApproveCount) > 0 &&
                    Number(invoiceCount) > 0
                  );
                  const isDisabledOther = (
                    proposalStatus !== "Accepted" &&
                    Number(creativeApproveCount) === 0 &&
                    Number(invoiceCount) === 0
                  );
              return (
                
                <Fragment key={index}>
                  
                  {status.applied_date && (
                    
                    <>
                      <span
                        className={`status-heading ${
                          isCurrentStep ? "selected" : ""
                        } ${isPreviouslySelected ? "selected previous" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCampaign(
                            status.url,
                            campaignId,
                            campaignPlatform
                          );
                        }}
                      >
                        <div className="status-heading-inner">
                          <strong>
                            {status.name}{" "}
                            <span
                              className="fs-14 d-flex d-md-block ms-1"
                              style={{ fontWeight: 400 }}
                            >
                              {status.applied_date && (
                                <span className="">{` on ${dayjs(
                                  status.applied_date
                                ).format("LL")}`}</span>
                              )}
                            </span>
                          </strong>
                        </div>
                      </span>
                      <span
                        className={`arrow ${
                          isPreviouslySelected ? "selected previous" : ""
                        }`}
                      >
                        <span className="material-symbols-rounded">
                          keyboard_arrow_right
                        </span>
                      </span>
                      
                    </>
                  )}

                  {status.name === "Proposal" && (
                    <>
                      <span
                        className={`status-heading status-proposal ${
                          [
                            "Pending",
                            "Accepted",
                            "Rejected",
                            "Negotiating",
                          ].includes(proposalStatus)
                            ? `proposal-${proposalStatus.toLowerCase()} ${
                                isCurrentStep ? "selected" : ""
                              } ${
                                isPreviouslySelected ||
                                creativeApproveCount > 0 ||
                                creativePendingCount > 0 ||
                                creativeRejectedCount > 0 ||
                                (proposalStatus === "Accepted" &&
                                  campaignType !== "Barter" &&
                                  ["Hold", "Live"].includes(campaignStatus))
                                  ? "selected previous"
                                  : ""
                              }`
                            : ""
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCampaign(
                            status.url,
                            campaignId,
                            campaignPlatform
                          );
                        }}
                      >
                        <div className="status-heading-inner">
                          <strong>
                            Status:{" "}
                            <span
                              className="fs-14 d-flex d-md-block ms-1"
                              style={{ fontWeight: 400 }}
                            >
                              {proposalStatus}
                            </span>
                          </strong>
                        </div>
                      </span>
                      <span
                        className={`arrow ${
                          isPreviouslySelected ? "selected previous" : ""
                        }`}
                      >
                        <span className="material-symbols-rounded">
                          keyboard_arrow_right
                        </span>
                      </span>
                    </>
                  )}

                  {(status.name === "Creatives" ||
                    status.name === "Send Invoice") && (
                    <>
                      {status.name === "Creatives" && (
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCampaign(
                              status.url,
                              campaignId,
                              campaignPlatform
                            );
                          }}
                          className={`status-heading ${
                            proposalStatus === "Accepted" &&
                            campaignType !== "Barter" &&
                            ["Hold", "Live"].includes(campaignStatus)
                              ? "selected"
                              : ""
                          } ${isCurrentStep ? "selected" : ""} ${
                            isPreviouslySelected || creativeApproveCount > 0
                              ? "selected previous"
                              : ""
                          }`}
                        >
                          <strong>Creatives</strong>
                          <ul className="campaign-creative">
                            {status.approve !== 0 &&
                              status.approve !== undefined && (
                                <Tooltip title="Approved" arrow>
                                  <li>
                                    <span className="d-md-none">Approved:</span>
                                    <span className="status color-approve ms-1">{`${status.approve}`}</span>
                                  </li>
                                </Tooltip>
                              )}
                            {status.pending !== 0 &&
                              status.pending !== undefined && (
                                <li>
                                  <span className="d-md-none">Pending:</span>
                                  <span className="status color-pending ms-1">{`${status.pending}`}</span>
                                </li>
                              )}
                            {status.reject !== 0 &&
                              status.reject !== undefined && (
                                <li>
                                  <span className="d-md-none">Rejected:</span>
                                  <span className="status color-reject ms-1">{`${status.reject}`}</span>
                                </li>
                              )}
                          </ul>

                          {proposalStatus === "Accepted" &&
                            campaignType !== "Barter" &&
                            ["Hold", "Live"].includes(campaignStatus) && (
                              <div className="send-invoice-sec">
                                <button
                                  className="btn btn-outline-primary btn-sm mt-1"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCampaign(
                                      "/influencer/campaign/sendinvoice",
                                      campaignId,
                                      campaignPlatform
                                    ); // Use the specific Send Invoice URL
                                  }}
                                >
                                  Send Invoice
                                </button>
                              </div>
                            )}
                        </span>
                      )}

                      <span
                        className={`arrow ${
                          isPreviouslySelected ? "selected previous" : ""
                        }`}
                      >
                        <span className="material-symbols-rounded">
                          keyboard_arrow_right
                        </span>
                      </span>
                    </>
                  )}

                  {status.name === "Analytics" && (
                    <>
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCampaign(
                            status.url,
                            campaignId,
                            campaignPlatform
                          );
                        }}
                        className={`status-heading ${
                          creativeApproveCount > 0 &&
                          ["Hold", "Live"].includes(campaignStatus)
                            ? "selected"
                            : ""
                        } ${isCurrentStep ? "selected" : ""} ${
                          isPreviouslySelected ? "selected previous" : ""
                        }`}
                      >
                        <strong>Analytics</strong>
                        {creativeApproveCount > 0 &&
                          ["Hold", "Live"].includes(campaignStatus) && (
                            <span className="fs-12">
                              Add post links to get analytics
                            </span>
                          )}
                      </span>
                      <span
                        className={`arrow ${
                          isPreviouslySelected ? "selected previous" : ""
                        }`}
                      >
                        <span className="material-symbols-rounded">
                          keyboard_arrow_right
                        </span>
                      </span>
                    </>
                  )}
                  
                  {["Mark Complete", "Marked Complete"].includes(status.name) && (
                    <span
                      id={`mark-complete-${proposalId}`}
                      className={`status-heading ${
                        status.name === "Marked Complete"
                          ? "selected"
                          : "mark-complete-event"
                      } ${isDisabled ? "" : "disabled"} ${isDisabledOther ? "enable" : ""}`}
                    >
                      <div
                        className={`status-heading-inner ${
                          status.name === "Marked Complete"
                            ? ""
                            : "mark-complete-event"
                        }`}
                      >
                        <strong
                          className={`${
                            status.name === "Marked Complete"
                              ? ""
                              : "mark-complete-event d-flex align-items-center"
                          }`}
                        >
                          {status.name}
                          {(!isDisabled && !isDisabledOther) ? <Tooltip arrow placement="top"
                          title={
                            <span>
                              <strong>Please note:</strong>  
                              <br />
                              The campaign cannot be marked as complete during the middle stages.
                              Completion is only possible once all agreed-upon deliverables have been fulfilled and reviewed.
                              <br /><br />
                              Feel free to reach out if you have any questions.
                            </span>
                          }>
                          <IconButton>
                            <MaterialSymbol iconName="info" fontweight="200" />
                          </IconButton>
                        </Tooltip> : ""}
                        </strong>
                        {completedAt && status.name === "Marked Complete" && (
                          <span className="fs-14 ms-1">{` on ${dayjs(
                            completedAt
                          ).format("LL")}`}</span>
                        )}
                      </div>
                    </span>
                  )}
                </Fragment>
              );
            })}
          </>
        </div>
      </div>)
    }</>
  );
};

export default MyCampaignCard;
